import { ArrowLeft, Info } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";

export default function DemoBanner() {
  const [minimized, setMinimized] = useState(false);

  if (minimized) {
    return (
      <button
        data-testid="demo-banner-expand"
        onClick={() => setMinimized(false)}
        className="fixed bottom-6 right-6 z-[9999] bg-[#0A0A0A] text-white px-4 py-3 rounded-full shadow-lg flex items-center gap-2 hover:scale-105 transition-transform"
        style={{ fontFamily: "'Outfit', sans-serif" }}
      >
        <Info size={18} />
        <span className="text-sm font-semibold">Demo Site</span>
      </button>
    );
  }

  return (
    <div
      data-testid="demo-banner"
      className="fixed bottom-0 left-0 right-0 z-[9999] bg-[#0A0A0A] border-t-4 border-[#FE4A90]"
      style={{ fontFamily: "'Outfit', sans-serif" }}
    >
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="bg-[#FE4A90] text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full">
            Demo
          </div>
          <p className="text-white/80 text-sm hidden sm:block">
            This is an example site built by <span className="text-white font-semibold">Corcoran Design</span>
          </p>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to="/"
            data-testid="demo-banner-back"
            className="flex items-center gap-2 bg-white text-[#0A0A0A] px-4 py-2 text-sm font-bold rounded-full hover:bg-[#FE4A90] hover:text-white transition-colors"
          >
            <ArrowLeft size={16} />
            Back to Portfolio
          </Link>
          <button
            data-testid="demo-banner-minimize"
            onClick={() => setMinimized(true)}
            className="text-white/50 hover:text-white transition-colors p-1"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 8h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
